import { CommonModule } from '@angular/common';
import { NgModule, PLATFORM_ID } from '@angular/core';

import { CoreModule } from '~/core/core.module';
import { FlagIsTrueDirective } from '~/paramethor/directives/flag-is-true.directive';
import { ParamethorService } from '~/paramethor/paramethor.service';
import { HttpClient, HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [FlagIsTrueDirective],
  providers: [
    {
      provide: ParamethorService,
      deps: [PLATFORM_ID, HttpClient],
    },
  ],
  imports: [CommonModule, CoreModule, HttpClientModule],
  exports: [FlagIsTrueDirective],
})
export class ParamethorModule {}
